import {Injectable, OnInit} from '@angular/core';

import {ItemMenu} from '@/app/common/interfaces/sidenav.types';
import {BehaviorSubject} from 'rxjs';
import {AccessService} from '@/app/features/access/services/service';

@Injectable({providedIn: 'root'})
export class SidenavService {
  private menu = new BehaviorSubject<ItemMenu[]>([]);

  menu$ = this.menu.asObservable();

  constructor(private accessService: AccessService) {
  }

  /**
   * @description Set args to item by menu, can be send when navigate by router
   * @param args
   * @param label
   * @param menu
   */
  setArgs(menu: ItemMenu[], label: string, args: object): void {
    menu.forEach((item) => {
      if (item.label.toLowerCase() === label.toLowerCase()) {
        item.args = args;
        return;
      }

      if (item.subMenu) {
        this.setArgs(item.subMenu, label, args);
      }
    });

    this.menu.next(menu);
  }

  /**
   * @description Toogle status to show item by label
   * @param label
   * @param menu
   * @param showItem
   */
  toogleShowItem(menu: ItemMenu[], label: string, showItem: boolean): void {
    menu.forEach((item) => {
      if (item.label.toLowerCase() === label.toLowerCase()) {
        item.hidden = showItem;
        return;
      }

      if (item.subMenu) {
        this.toogleShowItem(item.subMenu, label, showItem);
      }
    });

    this.menu.next(menu);
  }

  /**
   * @description Toogle status disabled for item in meny by label
   * @param label
   * @param menu
   * @param status
   */
  toogleDisableItem(menu: ItemMenu[], label: string, status: boolean): void {
    menu.forEach((item) => {
      if (item.label.toLowerCase() === label.toLowerCase()) {
        item.disabled = status;
        return;
      }

      if (item.subMenu) {
        this.toogleDisableItem(item.subMenu, label, status);
      }
    });

    this.menu.next(menu);
  }

  loadMenu() {
    const baseMenu: ItemMenu[] = [
      {
        label: `Dashboard`,
        path: '/dashboard',
        icon: 'dashboard'
      },
      {
        label: 'Check-lists',
        path: '/home',
        icon: 'home',
      },
       {
        label: 'Manutenções',
        path: '/maintenance',
        icon: 'build',
      },
    ];

    if (this.accessService.hasPermission('ADMIN')) {
      baseMenu.push(
        {
          label: 'Ficha de veículos',
          path: '/fleet',
          icon: 'directions_car',
        },
        {
          label: 'Revisões',
          path: '/revisions',
          icon: 'car_repair',
        },
        {
          label: 'Rastreador',
          path: '/tracker',
          icon: 'my_location',
        },
      );
    }

    this.menu.next(baseMenu);
  }
}
